import styled from "styled-components";
import SimpleBadge from "@vfuk/core-simple-badge";

export type BadgeState =
  | "success"
  | "error"
  | "warn"
  | "incomplete"
  | "info"
  | "partial";

// Gets the correct Badge state colour
const getColor = (state: BadgeState) => {
  switch (state.toLowerCase()) {
    case "success":
      return "rgb(0, 138, 0)";
    case "error":
      return "rgb(189, 0, 0)";
    case "warn":
      return "rgb(235,151,0)";
    case "incomplete":
      return "rgb(190, 190, 190)";
    case "info":
      return "rgb(0, 94, 165)";
    case "partial":
      return "rgb(156,41,160)";
    default:
      return "rgb(189, 0, 0)";
  }
};

const BadgeStyles = styled.div<{ state: BadgeState }>`
  div {
    background-color: ${({ state }) => getColor(state)};
  }
`;

const Badge = ({ state }: { state: BadgeState }) => (
  <BadgeStyles state={state}>
    <SimpleBadge />
  </BadgeStyles>
);

export default Badge;
